(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive-floating-actions"] && !Shopify.designMode) return;
  try {
    
  class ArchiveFloatingActions extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('shopify:cart:lines-update', this.onCartUpdate, options);
      window.addEventListener('pageshow', this.onPageShow, options);
      this.querySelector('[data-floating-cart]')?.addEventListener('click', this.openCart, options);
      const stickyBar = document.querySelector('sticky-add-to-cart [ref="stickyBar"]');
      if (stickyBar) {
        this.stickyBar = stickyBar;
        this.stickyObserver = new MutationObserver(this.updateOffset);
        this.stickyObserver.observe(stickyBar, { attributes: true, attributeFilter: ['data-stuck'] });
        this.resizeObserver = new ResizeObserver(this.updateOffset);
        this.resizeObserver.observe(stickyBar);
        this.updateOffset();
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.stickyObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }

    setCount = (count) => {
      if (!Number.isInteger(count) || count < 0) return;
      const target = this.querySelector('[data-floating-count]');
      if (target && target.textContent !== String(count)) target.textContent = String(count);
    };

    onCartUpdate = (event) => {
      event.promise?.then(({ cart, detail }) => {
        this.setCount(cart?.totalQuantity ?? detail?.itemCount);
      }).catch(() => {});
    };

    onPageShow = (event) => {
      if (!event.persisted) return;
      fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' }, signal: this.controller.signal })
        .then((response) => response.ok ? response.json() : null)
        .then((cart) => this.setCount(cart?.item_count))
        .catch(() => {});
    };

    openCart = (event) => {
      if (!this.hasAttribute('data-cart-drawer') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const drawer = document.querySelector('cart-drawer-component')?.closest('theme-drawer');
      if (typeof drawer?.open !== 'function') return;
      event.preventDefault();
      drawer.open();
    };

    updateOffset = () => {
      const height = this.stickyBar?.dataset.stuck === 'true' ? this.stickyBar.getBoundingClientRect().height + 20 : 0;
      this.style.setProperty('--archive-cart-offset', `${Math.ceil(height)}px`);
    };
  }

  if (!customElements.get('archive-floating-actions')) {
    customElements.define('archive-floating-actions', ArchiveFloatingActions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
